import gql from 'graphql-tag';

export const DeleteDispatchSummary = gql`
  mutation DeleteDispatchSummaryBulk($input: DeleteDispatchSummaryBulkInput!) {
    deleteDispatchSummaryBulk(input: $input) {
      deleted
    }
  }
`;
